import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { getMonth, getYear } from 'date-fns'
import { Article, SpinnerCard } from '../common/Layout'
import CheckoutForm from './CheckoutForm'
import {
  findSelectedCreditCard,
  selectCheckoutUser,
  selectSuggestedCredits,
  selectUserLocationId,
  selectProfile
} from '../../redux/modules/selectors'
import {
  checkoutStart,
  applyCoupon,
  applyCredit,
  loadCreditCardsStart,
  clearError
} from '../../redux/modules/checkout'
import { loadCheckoutCartStart } from '../../redux/modules/cart'
import { loadDeliveryDropoffStart } from '../../redux/modules/delivery'
import ValidationModal from '../place-order/ValidationModal'
import { loadAvailableCreditsStart } from '../../redux/modules/creditHistory'
import { loadLocationStart } from '../../redux/modules/location'
import { loadProfileStart } from '../../redux/modules/profile'

const CheckoutFormContainer = reduxForm({ form: 'checkout' })(CheckoutForm)

class Checkout extends Component {
  componentDidMount() {
    const {
      loadAvailableCreditsStart,
      loadCheckoutCartStart,
      loadCreditCardsStart,
      loadDeliveryDropoffStart,
      loadLocationStart
    } = this.props
    let {
      match: {
        params: { locationId = 0, dropoffId = 0 }
      }
    } = this.props
    dropoffId = Number(dropoffId)
    locationId = Number(locationId)

    loadCreditCardsStart()
    loadAvailableCreditsStart()
    if (locationId) {
      loadLocationStart(locationId)
    }
    if (dropoffId) {
      loadDeliveryDropoffStart(dropoffId)
      loadCheckoutCartStart(dropoffId)
    }
  }

  componentDidUpdate(prevProps) {
    const {
      loadLocationStart,
      loadCheckoutCartStart,
      loadDeliveryDropoffStart
    } = this.props
    let {
      match: {
        params: { locationId = 0, dropoffId = 0 }
      }
    } = this.props
    dropoffId = Number(dropoffId)
    locationId = Number(locationId)

    if (locationId !== Number(prevProps.match.params.locationId)) {
      loadLocationStart(locationId)
      if (dropoffId !== Number(prevProps.match.params.dropoffId)) {
        loadCheckoutCartStart(dropoffId)
      }
    }
    if (dropoffId !== Number(prevProps.match.params.dropoffId)) {
      loadDeliveryDropoffStart(dropoffId)
    }
  }

  componentWillUnmount() {
    this.props.clearError()
  }

  render() {
    const {
      applyCoupon,
      applyCredit,
      availableCredits,
      checkoutCart,
      checkoutError,
      checkoutStart,
      checkoutUser,
      couponError,
      couponUsage,
      creditCards,
      creditCardsError,
      creditError,
      creditUsage,
      deliveryError,
      isAvailableCreditsLoading,
      isCheckoutCartLoading,
      isCouponApplying,
      isCreditApplying,
      isCreditCardsLoading,
      isCurrentUserLoading,
      isLoadingProfile,
      profile,
      selectedCreditCard,
      suggestedCredits
    } = this.props

    let {
      match: {
        params: { locationId = 0 }
      }
    } = this.props
    locationId = Number(locationId)
    const now = new Date()

    if (deliveryError) {
      const serverMessage = deliveryError.response
        ? deliveryError.response.data
        : ''
      return (
        <ValidationModal
          serverMessage={serverMessage}
          locationId={locationId}
        />
      )
    }

    return (
      <Article>
        <SpinnerCard
          spinnerActive={
            isLoadingProfile || isCurrentUserLoading || isCreditCardsLoading
          }
        >
          <h1 className="title">Checkout</h1>
          <CheckoutFormContainer
            initialValues={{
              User: { ...checkoutUser, ...profile },
              saveCard: true,
              cc: { expMonth: getMonth(now) + 1, expYear: getYear(now) },
              SelectedCard:
                checkoutCart.orderTotal === 0
                  ? null
                  : creditCards.length === 1
                  ? creditCards[0].ccProfileId
                  : creditCards.length > 0
                  ? null
                  : -1
            }}
            applyCoupon={applyCoupon}
            applyCredit={applyCredit}
            creditCards={creditCards}
            checkoutError={checkoutError}
            couponError={couponError}
            creditError={creditError}
            coupon={couponUsage}
            credit={creditUsage}
            onSubmit={checkoutStart}
            user={{ ...checkoutUser, ...profile }}
            {...{
              applyCoupon,
              applyCredit,
              creditCards,
              checkoutError,
              couponError,
              creditError,
              creditCardsError,
              availableCredits,
              isAvailableCreditsLoading,
              isCheckoutCartLoading,
              suggestedCredits,
              selectedCreditCard,
              checkoutCart,
              isCouponApplying,
              isCreditApplying
            }}
          />
        </SpinnerCard>
      </Article>
    )
  }
}

const mapStateToProps = state => {
  const {
    creditCards,
    couponError,
    creditError,
    creditCardsError,
    isCreditCardsLoading,
    checkoutError,
    isCreditApplying,
    isCouponApplying
  } = state.checkout
  const deliveryError = state.delivery.error
  const { currentUser, isCurrentUserLoading } = state.user
  const { availableCredits, isAvailableCreditsLoading } = state.creditHistory
  const {
    checkoutCart,
    isCheckoutCartLoading,
    couponUsage,
    creditUsage
  } = state.cart
  const { isLoadingProfile } = state.profile
  const profile = selectProfile(state)
  const selectedCreditCard = findSelectedCreditCard(state)
  const locationId = selectUserLocationId(state)
  return {
    selectedCreditCard,
    creditCards,
    couponUsage,
    creditUsage,
    couponError,
    creditError,
    creditCardsError,
    checkoutCart,
    checkoutError,
    isCouponApplying,
    isCreditApplying,
    currentUser,
    checkoutUser: selectCheckoutUser(state),
    suggestedCredits: selectSuggestedCredits(state),
    isCurrentUserLoading,
    isCreditCardsLoading,
    isCheckoutCartLoading,
    deliveryError,
    locationId,
    profile,
    isLoadingProfile,
    availableCredits,
    isAvailableCreditsLoading
  }
}

const mapDispatchToProps = {
  loadCheckoutCartStart,
  loadDeliveryDropoffStart,
  checkoutStart,
  loadCreditCardsStart,
  clearError,
  applyCoupon,
  applyCredit,
  loadAvailableCreditsStart,
  loadProfileStart,
  loadLocationStart
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Checkout)
